import { render, staticRenderFns } from "./project-page.vue?vue&type=template&id=c72ac1a2&"
import script from "./project-page.vue?vue&type=script&lang=ts&"
export * from "./project-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72ac1a2')) {
      api.createRecord('c72ac1a2', component.options)
    } else {
      api.reload('c72ac1a2', component.options)
    }
    module.hot.accept("./project-page.vue?vue&type=template&id=c72ac1a2&", function () {
      api.rerender('c72ac1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-page/project-page.vue"
export default component.exports